import { IVec2 } from "../utils/vec2";

export enum StageShape {
    Rectangle = 'rectangle',
    Oval = 'oval',
}

export interface IStage {
    shape: StageShape;
    size: IVec2;
}
